module.exports = __webpack_public_path__ + "img/187.f9e2bce6.jpg";